import { Box } from "@mui/material";
import ContainedButton from "../../../../../../../../components/buttons/ContainedButton";
import TextButton from "../../../../../../../../components/buttons/TextButton";

export default function ButtonsSection({
  step,
  setStep,
  numberOfSteps,
  handleClose,
  accepted,
  handleConfirmation,
  loadingConfirmation,
  anyEntitySelected,
}) {
  const applyAutoRemediationDisabled = step === numberOfSteps && !accepted;

  return (
    <Box display="flex" gap={2} alignItems="center" justifyContent="center">
      <TextButton
        onClick={step === 1 ? handleClose : () => setStep((prev) => prev - 1)}
        color="inherit"
        size="small"
        disabled={loadingConfirmation}
      >
        {step === 1 ? "Cancel" : "Back"}
      </TextButton>
      <ContainedButton
        onClick={
          step === numberOfSteps
            ? handleConfirmation
            : () => setStep((prev) => prev + 1)
        }
        color="primary"
        size="small"
        disabled={applyAutoRemediationDisabled || !anyEntitySelected}
        loading={loadingConfirmation}
        sxProps={{
          transition: "none",
        }}
      >
        {step === numberOfSteps ? "Approve and Apply" : "Next"}
      </ContainedButton>
    </Box>
  );
}
